module.exports = __webpack_public_path__ + "static/media/icn_kyc_completed.01b563f0.svg";